"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTC = function FlagTC(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M82.26-27.84a1.55,1.55,0,0,0-1.55,1.54V-.08c0,52.44,37,61.69,37,61.69s37-9.25,37-61.69V-26.3a1.55,1.55,0,0,0-1.55-1.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M150.89-24V-.08c0,44.6-27.57,55.85-33.16,57.67C112.11,55.76,84.57,44.5,84.57-.08V-24h66.32m2.31-3.86H82.26a1.55,1.55,0,0,0-1.55,1.54V-.08c0,52.44,37,61.69,37,61.69s37-9.25,37-61.69V-26.3a1.55,1.55,0,0,0-1.55-1.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M121.87,21H114s-6.36,6.37-7.82,20.34a1.33,1.33,0,0,0,.48,1.18,20.09,20.09,0,0,0,22.57,0,1.33,1.33,0,0,0,.48-1.18c-1.46-14-7.82-20.34-7.82-20.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M121.87,19.7H114V13.12a3.95,3.95,0,0,1,7.89,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M121.87,22.33H114a1.32,1.32,0,1,1,0-2.63h7.89a1.32,1.32,0,1,1,0,2.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M148.17-6.75a48.58,48.58,0,0,0-7.23.63V-8.18a37,37,0,0,1,6-2.09.67.67,0,0,0,.49-.79.65.65,0,0,0-.79-.49,36.13,36.13,0,0,0-5.74,1.94,3.89,3.89,0,0,0-.76-2.11,43.45,43.45,0,0,1,4.4-3,.65.65,0,0,0,.25-.89.66.66,0,0,0-.9-.25,44.11,44.11,0,0,0-4.71,3.22,3.89,3.89,0,0,0-2.2-.67,4,4,0,0,0-2.27.72,10.23,10.23,0,0,1,2.08-4.86.66.66,0,0,0,0-.93.65.65,0,0,0-.93,0A10.27,10.27,0,0,0,133.7-14a10.2,10.2,0,0,0-2.16-4.36.65.65,0,0,0-.93,0,.68.68,0,0,0,0,.93,10.17,10.17,0,0,1,2.09,4.86,4,4,0,0,0-2.27-.72,4,4,0,0,0-2.2.67,44.11,44.11,0,0,0-4.71-3.22.66.66,0,0,0-.9.25.65.65,0,0,0,.25.89,46.22,46.22,0,0,1,4.4,3,3.89,3.89,0,0,0-.76,2.11,36.13,36.13,0,0,0-5.74-1.94.65.65,0,0,0-.79.49.66.66,0,0,0,.49.79,37,37,0,0,1,6,2.09v2.06a48.58,48.58,0,0,0-7.23-.63.66.66,0,0,0-.66.66.67.67,0,0,0,.66.66,48,48,0,0,1,7.23.64v2.13a13.09,13.09,0,0,0-6.21,1.24.66.66,0,0,0-.3.88.67.67,0,0,0,.59.37.82.82,0,0,0,.3-.07,11.52,11.52,0,0,1,5.62-1.08V6.81a15.65,15.65,0,0,1-.29,3l-1,5a.65.65,0,0,0,.51.77l.13,0a.67.67,0,0,0,.65-.53l1-5a16.69,16.69,0,0,0,.32-3.23v-8a19.47,19.47,0,0,1,2.58.47l.5,6.51a2.82,2.82,0,0,0,1.06,2l-2.13,3.2A2.58,2.58,0,0,0,132,15h3.51a2.58,2.58,0,0,0,2.15-4l-2.14-3.2a2.83,2.83,0,0,0,1.07-2L137-.76a19.65,19.65,0,0,1,2.59-.47v8a16.76,16.76,0,0,0,.32,3.23l1,5a.66.66,0,0,0,.64.53l.13,0a.65.65,0,0,0,.52-.77l-1-5a15.65,15.65,0,0,1-.29-3V-1.33a11.77,11.77,0,0,1,5.62,1.08.59.59,0,0,0,.29.07.66.66,0,0,0,.59-.36.66.66,0,0,0-.29-.88,13,13,0,0,0-6.22-1.24V-4.79a48.89,48.89,0,0,1,7.24-.65.65.65,0,0,0,.65-.65.64.64,0,0,0-.65-.66Zm-8.55.88a20,20,0,0,0-2.28.62,4.81,4.81,0,0,0-.12-.76,18.17,18.17,0,0,1,2.4-1.53v1.67Zm0-3.51V-9a19.83,19.83,0,0,0-3,1.8,3.37,3.37,0,0,0-.67-.69,31.45,31.45,0,0,1,3.15-3,2.52,2.52,0,0,1,.5,1.52ZM137-12a2.68,2.68,0,0,1,1.1.24,31.4,31.4,0,0,0-3.32,3.22l-.41-.11v-.06c0-.3,0-.59,0-.87A2.63,2.63,0,0,1,137-12Zm-6.57,0A2.63,2.63,0,0,1,133-9.59c0,.29,0,.57,0,.87v.07a2.73,2.73,0,0,0-.41.1,30.34,30.34,0,0,0-3.32-3.21,2.57,2.57,0,0,1,1.1-.25Zm-2.63,2.63a2.57,2.57,0,0,1,.5-1.53,31.57,31.57,0,0,1,3.15,3,3.37,3.37,0,0,0-.67.69,20.34,20.34,0,0,0-3-1.8Zm0,1.85A16.33,16.33,0,0,1,130.19-6a3.67,3.67,0,0,0-.11.75,20.8,20.8,0,0,0-2.29-.62Zm0,5V-4.52a19.6,19.6,0,0,1,2.35.68l.13,1.69a20.55,20.55,0,0,0-2.48-.42Zm11.83,0a20.55,20.55,0,0,0-2.48.42l.13-1.69a19.6,19.6,0,0,1,2.35-.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#d35a10"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M106.63,11h-3L92.39,1A4.42,4.42,0,0,1,91-3.42L94.18-16a1.48,1.48,0,0,1,2.48-.68l5.1,5.1a1.48,1.48,0,0,0,1,.44h3.81V11Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffa033"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M104.51-14.18,102.7-6a8.91,8.91,0,0,0,.16,4.47L106.63,11h3l3.77-12.55A8.91,8.91,0,0,0,113.51-6l-1.81-8.16a3.69,3.69,0,0,0-3.6-2.88h0a3.67,3.67,0,0,0-3.59,2.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff9480"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M108.1-14.11a1.47,1.47,0,0,0-1.47,1.48V11h3V-12.63a1.48,1.48,0,0,0-1.48-1.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffa0e4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTC;
exports["default"] = _default;